import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useAtom } from "jotai";
import settingsAtom from "../../../../atoms/settings/SettingsAtom";
import LayoutComponent from "../../../../components/dashboard/Mapview/LayoutComponent";
import dashboardAtoms, { fetchBlocks, fetchBulkData, fetchMapSize, fetchpierlegends } from "../../../../atoms/Dashboard/DashboardAtom";
import ToggleButtonComponent from "../../../../shared/Dashboard/ToogleButton";
import LockUnlockRightPanel from "./rightPanel";
import { SectionList } from "../../../../shared/Helper";
import MultipleSelectComponent from "../../../../shared/MultiSelectComponent";
import { getSelectedTrackerRows, handleSelectionChange } from "@product-fusion/surya-fw/dist/utils/selectionUtils";
import punchListAtom, { fetchLockTrackerDetailsAtom, fetchQCProgressAtom, updateLockTrackersAtom } from "../../../../atoms/quality/QualityAtoms";
const BlockDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const projectId = localStorage.getItem("project_id");
    const path = useLocation();
    const [loader, setLoader] = useState(false);
    const [data] = useAtom(dashboardAtoms);
    const [list] = useAtom(punchListAtom);
    const [settings] = useAtom(settingsAtom);
    const [, setMapSize] = useAtom(fetchMapSize);
    const [, setBulk] = useAtom(fetchBulkData);
    const [, setBlock] = useAtom(fetchBlocks);
    const [, setPiers] = useAtom(fetchpierlegends);
    const [, setQCProgress] = useAtom(fetchQCProgressAtom)
    const [, setUpdateLockTrackers] = useAtom(updateLockTrackersAtom)
    const [, setLockTrackerDetails] = useAtom(fetchLockTrackerDetailsAtom)
    const [view, setView] = useState("Lock/Unlock");
    const [active, setActive] = useState("external");
    const [selectedRow, setSelectedRow] = useState({
        count: null,
        sections: {},
        trackerTypes: {}
    });
    const [section, setSection] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedTrackerRows, setSelectedTrackerRows] = useState([]);
    const [scope, setScope] = useState("piers");
    const [buttonLoading, setButtonLoading] = useState({
        lock: false,
        unlock: false
    });

    const [loading, setLoading] = useState(false)

    const fetchAllData = useCallback(async () => {
        setLoader(true);
        try {
            await Promise.allSettled([
                setBulk(id),
                setMapSize(id),
                setLockTrackerDetails(id, 1, "piers"),
                setBlock(),
                setPiers(""),
                getQCProgressColor()

            ]);
            

        } catch (error) {
            console.error("❌ Error in fetchAllData:", error);
        } finally {
            setLoader(false);
        }
        // eslint-disable-next-line
    }, [path?.pathname, setBulk, setMapSize,setBlock]);

    useEffect(() => {
        if (projectId && id) {
            fetchAllData();
        }
    }, [projectId, fetchAllData, id]);

    useEffect(() => {
        if (view === "Logs") {
            navigate("/quality/logs-and-checklists");
        }
        // eslint-disable-next-line
    }, [view]);

    const handleSectionChange = async (event) => {
        const value = event.target.value;
        const data = section.filter((item) => !value.includes(item));

        setSection(typeof value === 'string' ? value.split(',') : value);

        const sectionValue = await handleSelectionChange("section", value, data);
        setSelectedRow(sectionValue);
    };

    const handleClickSelectAll = async () => {
        const sectionValue = await handleSelectionChange("selectAll");
        setSelectedRow(sectionValue);
        setSelectAll(true);
        setSection(SectionList(data?.bulkAllData?.piers));
    };

    const handleClearSelection = async () => {
        await handleSelectionChange("clear");
        setSelectedRow({
            count: null,
            sections: {},
            trackerTypes: {}
        });
        setSelectAll(false);
        setSection([]);
    };


    const handleLockSelected = async () => {

        try {
            setButtonLoading(prev => ({ ...prev, lock: true }));
            await setUpdateLockTrackers([{
                tracker_row_ids: selectedTrackerRows,
                lock: true,
                visibility: active === "external" ? 1 : 0,
                scope: scope
            }])
            await setLockTrackerDetails(id, active === "external" ? 1 : 0, scope)
            await handleClearSelection();
        } catch (error) {
            console.error("Error locking trackers:", error);
        } finally {
            setButtonLoading(prev => ({ ...prev, lock: false }));
        }
    };

    const handleUnlockSelected = async () => {
        try {
            setButtonLoading(prev => ({ ...prev, unlock: true }));
            await setUpdateLockTrackers([{
                tracker_row_ids: selectedTrackerRows,
                lock: false,
                visibility: active === "external" ? 1 : 0,
                scope: scope
            }])
            await setLockTrackerDetails(id, active === "external" ? 1 : 0, scope)
            // Clear selection after successful operation
            await handleClearSelection();
        } catch (error) {
            console.error("Error unlocking trackers:", error);
        } finally {
            setButtonLoading(prev => ({ ...prev, unlock: false }));
        }
    };
    useEffect(() => {

        getQCProgressColor()

        // eslint-disable-next-line
    }, [scope, active])
    const getQCProgressColor = async () => {
        try {
            setQCProgress({ blockId: id, Scope: scope, visibility: active === "external" ? 1 : 0 })
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(() => {
        let selectedTrackers = getSelectedTrackerRows();
        setSelectedTrackerRows(selectedTrackers);
    }, [selectedRow]);

    const handleChangeScope = async (value) => {
        setLoading(true)
        try {
            setScope(value)
            await setLockTrackerDetails(id, active === "external" ? 1 : 0, value)
        } catch(err) {
            console.error(err)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Box >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "start", py: 2, px: 2 }}>
                <Typography variant="span" fontSize={22} sx={{ fontWeight: "bold" }}>
                    Lock and Unlock</Typography>
                <ToggleButtonComponent
                    data={["Lock/Unlock", "Logs"]}
                    active={view}
                    setActive={setView}
                />
            </Box>
            <Box sx={{ borderTop: '1px solid #e0e0e0' }}></Box>
            <Box px={2}>
                <Box sx={{ display: 'flex', width: '100%', position: "relative" }}>

                    <Box sx={{ height: 'calc(100vh - 200px)', width: "70%", borderRight: '1px solid #e0e0e0' }}>
                        {loader ?
                            <Box sx={{
                                height: 'calc(100vh - 200px)',
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                <CircularProgress />
                            </Box>
                            :
                            <>
                                <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", m: -2, pt: 2, pr: 2 }}>
                                    <MultipleSelectComponent
                                        data={SectionList(data?.bulkAllData?.piers)}
                                        section={section}
                                        setSection={handleSectionChange}
                                    />
                                    <Button
                                        variant="contained"
                                        onClick={handleClickSelectAll}
                                        sx={{
                                            margin: 1,
                                            minWidth: '120px',
                                            backgroundColor: !selectAll ? '#f16253' : '#ccc',
                                            '&:hover': {
                                                backgroundColor: !selectAll ? '#d9493a' : '#ccc'
                                            }
                                        }}
                                    >
                                        Select All
                                    </Button>
                                    <Button
                                        variant="contained"
                                        disabled={selectedTrackerRows.length === 0}
                                        onClick={handleClearSelection}
                                        sx={{
                                            margin: 1,
                                            minWidth: '120px',
                                            backgroundColor: selectedTrackerRows.length > 0 ? '#f16253' : '#ccc',
                                            '&:hover': {
                                                backgroundColor: selectedTrackerRows.length > 0 ? '#d9493a' : '#ccc'
                                            }
                                        }}
                                    >
                                        Clear Selection
                                    </Button>

                                </Box>
                                <LayoutComponent
                                    loader={loader || loading}
                                    data={data}
                                    qcProgressData={list?.qcProgressColor}
                                    lockUnlockData={list?.lockTrackerData}
                                    projectList={settings?.projectList}
                                    setSelectedRow={setSelectedRow}
                                    selectedRow={selectedRow}
                                    userSelection={{
                                        showType: "pier",
                                        selection: scope,

                                    }}
                                    currentSelection={scope}
                                    lockTypeSelection={active === "external" ? "qc_external" : "qc_internal"}
                                    layoutType="QC"
                                />
                            </>
                        }
                    </Box>
                    <Box sx={{ height: 'calc(100vh - 200px)', width: '30%' }} >
                        <LockUnlockRightPanel
                            selectedTrackerRows={selectedTrackerRows}
                            onLockSelected={handleLockSelected}
                            onUnlockSelected={handleUnlockSelected}
                            active={active}
                            setActive={setActive}
                            scope={scope}
                            setScope={handleChangeScope}
                            buttonLoading={buttonLoading}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default BlockDetail;